import cn from 'classnames'
import { useTheme } from '@hooks/contexts/ThemeContext/ThemeContext'

export function EndChapter() {
  const { isLightOrSepiaTheme, isNightOrDarkTheme, isNightTheme, isDarkTheme } =
    useTheme()
  return (
    <div
      className={cn(
        'flex items-center space-x-[10px] m-auto max-w-[700px] text-[18px] font-medium pt-[50px]',
        {
          'text-secondary': isLightOrSepiaTheme,
          'text-white': isNightTheme,
          'text-gray-16': isDarkTheme,
        }
      )}
    >
      <hr
        className={cn('flex-1', {
          'text-gray-3': isLightOrSepiaTheme,
          'text-white/10': isNightOrDarkTheme,
        })}
      />
      <span>จบตอน</span>
      <hr
        className={cn('flex-1', {
          'text-gray-3': isLightOrSepiaTheme,
          'text-white/10': isNightOrDarkTheme,
        })}
      />
    </div>
  )
}
